import { Menu } from 'antd';
import cx from 'classnames';
import React from 'react';
import { SelectOptions } from '../../../model/CommonModel';
import { ContextMenuPosition } from '../../../model/GraphicModel';
import styles from './contextMenu.module.scss';

const { Item, SubMenu } = Menu;

type ContextMenuProps<T> = {
	contextMenuPosition: ContextMenuPosition;
	contextMenuItems: SelectOptions<T>[];
	handleOnClickContextMenuItem: (value: T) => void;
};

export const ContextMenu = <T extends {}>({ contextMenuPosition, contextMenuItems, handleOnClickContextMenuItem }: ContextMenuProps<T>) => {
	const createMenuItems = (items: SelectOptions<T>[]) => {
		const menuItems: JSX.Element[] = [];

		items.forEach(({ label, disabled, title, icon, id, separator, value, nestedOptions }, index) => {
			const key = `${label}-${index}`;

			if (!nestedOptions) {
				menuItems.push(
					<Item
						className={cx({ [styles.separator]: separator, [styles.disabled]: disabled })}
						disabled={disabled}
						icon={icon}
						id={id}
						key={key}
						onClick={e => {
							e.domEvent.stopPropagation();
							handleOnClickContextMenuItem?.(value);
						}}
						title={title}>
						<span
							className={styles.internalSpan}
							onClick={e => {
								if (disabled) e.stopPropagation();
							}}>
							{label}
						</span>
					</Item>
				);
			} else {
				menuItems.push(
					<SubMenu className={cx({ [styles.separator]: separator })} key={key} title={label}>
						{createMenuItems(nestedOptions)}
					</SubMenu>
				);
			}
		});

		return menuItems;
	};

	const menu: JSX.Element = (
		<Menu mode='vertical' getPopupContainer={_ => document.getElementById('contextMenuContainer')}>
			{createMenuItems(contextMenuItems)}
		</Menu>
	);

	return (
		<div
			className={styles.contextMenu}
			id='contextMenuContainer'
			style={{
				top: contextMenuPosition.y,
				left: contextMenuPosition.x,
			}}>
			{menu}
		</div>
	);
};
